<template>
  <div>
    <Card>
      <Row>
        <Button style="float: right; " @click="addRole" type="primary" :style="{marginBottom: '10px'}" icon="md-add">添加角色</Button>
      </Row>
      <tables border search-place="bottom" v-model="tableData" :columns="columns"/>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getRolesList"></page>
        </div>
      </div>
      <Drawer
        :title="changeTitle"
        v-model="change"
        width="667"
        :mask-closable="true"
        @on-close="drawerClose"
      >
        <i-form ref="formItem" :model="formItem" :label-width="75" :rules="ruleValidate">
          <form-item label="角色名称" prop="name">
            <i-input v-model="formItem.name" placeholder=""></i-input>
          </form-item>
          <form-item label="角色描述" prop="description">
            <i-input v-model="formItem.description" placeholder=""></i-input>
          </form-item>
          <form-item label="关联用户" prop="users">
            <transfer
              :data="no_select_user"
              :target-keys="formItem.users"
              :list-style="listStyle"
              @on-change="userChange"
              filterable></transfer>
          </form-item>
          <form-item label="关联用户组" prop="groups">
            <transfer
              :data="no_select_group"
              :target-keys="formItem.groups"
              :list-style="listStyle"
              @on-change="groupChange"
              filterable></transfer>
          </form-item>
          <form-item>
            <i-button type="primary" @click="handleSubmit('formItem')">提交</i-button>
            <i-button style="margin-left: 8px" @click="change=false">取消</i-button>
          </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>请求中</div>
        </spin>
      </Drawer>
      <Drawer
        :title="changeTitle"
        v-model="changePermissions"
        :width="600"
        :mask-closable="true"
        @on-close="drawerClosePermissions"
      >
        <Tabs v-model="defaultIndex" @on-click="handleTabClick">
          <TabPane label="菜单权限" name="menuPerm">
            <OperateMenu ref="operateRoleMenu" :role_id="formItem.id" :menus="formItem.menuItems" :handleChangePermissions="this.handleChangePermissions"></OperateMenu>
          </TabPane>
          <TabPane label="操作权限" name="operatePerm">
            <OperatePerm ref="operatePerm" :formItem="formItemCp" :handleChangePermissions="this.handleChangePermissions"/>
          </TabPane>
          <!-- <TabPane label="数据权限" name="dataPerm">
             <DataPerm ref="operatePerm" :formItem="formItemCp" :handleChangePermissions="this.handleChangePermissions"/>
          </TabPane> -->
      </Tabs>
      </Drawer>
    </Card>
  </div>
</template>

<script>
import Tables from '_c/tables'
import { getRoles, changeRole, deleteRole, getAllPermission, getAllGroup, GetALLUsers } from '@/api/user'
import OperatePerm from './OperatePerm'
import DataPerm from './DataPerm'
import OperateMenu from './role-menu-manage'
export default {
  name: 'role-manage',
  components: {
    Tables,
    OperatePerm,
    DataPerm,
    OperateMenu
  },
  data () {
    return {
      defaultIndex: 'menuPerm',
      changePermissions: false,
      change: false,
      count: 1,
      size: 10,
      page: 1,
      changeTitle: '添加角色',
      columns: [
        { title: '角色', key: 'name', align: 'center', minWidth: 110 },
        { title: '关联用户', key: 'users_name', align: 'center', minWidth: 200 },
        { title: '关联用户组', key: 'groups_name', align: 'center', minWidth: 100 },
        {
          title: '操作',
          minWidth: 230,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.edit(params)
                  }
                }
              }, '分配用户'),
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.editPermissions(params)
                  }
                }
              }, '设置权限'),
              h('Poptip', {
                props: {
                  confirm: true,
                  placement: 'bottom',
                  title: '你确定要删除吗?'
                },
                on: {
                  'on-ok': () => {
                    this.handleDelete(params)
                  }
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  }
                }, '删除')
              ])
            ])
          }
        }
      ],
      tableData: [],
      changeLoadingShow: false,
      formItem: {
        id: 0,
        name: '',
        groups: [],
        users: [],
        description: '',
        permissions: [],
        menuItems: []
      },
      formItemCp: {},
      no_select_permission: [],
      no_select_group: [],
      no_select_user: [],
      listStyle: {
        width: '250px',
        height: '300px'
      },
      ruleValidate: {
        name: [
          { required: true, message: '角色名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  mounted: function () {
    this.getRolesList()
    // this.getNoSelectPermission()
    this.getNoSelectGroup()
    this.getNoSelectUser()
    this.getMenuTree()
  },
  methods: {
    addRole () {
      this.drawerClose()
      this.change = true
    },
    edit (params) {
      // console.log(params)
      this.formItem.id = params.row.id
      this.formItem.name = params.row.name
      this.formItem.description = params.row.description
      this.formItem.users = params.row.users
      this.formItem.groups = params.row.groups
      this.formItem.permissions = params.row.permissions
      this.change = true
      this.changeTitle = params.row.name + ' -- 分配用户'
    },
    editPermissions (params) {
      this.formItem.id = params.row.id
      this.formItem.name = params.row.name
      this.formItem.description = params.row.description
      this.formItem.users = params.row.users
      this.formItem.groups = params.row.groups
      this.formItem.permissions = params.row.permissions
      this.formItemCp = JSON.parse(JSON.stringify(this.formItem))
      // console.log(this.formItem)
      this.changePermissions = true
      this.changeTitle = params.row.name + ' -- 权限设置'
      this.formItem.menuItems = params.row.menu
    },
    handleSubmit (name) {
      // let that = this.formItem
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.changeLoadingShow = true
          changeRole(this.formItem, this.formItem.id).then(res => {
            this.$Notice.success({ title: '操作成功！' })
            this.change = false
            this.getRolesList(this.page)
          }).catch(res => {
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.request.status,
              desc: res.request.responseText
            })
          })
        } else {
          this.$Notice.error({ title: '请检查输入框！' })
        }
        this.changeLoadingShow = false
      })
    },
    drawerClose () {
      let that = this.formItem
      that.id = 0
      that.name = ''
      that.description = ''
      that.users = []
      that.groups = []
      that.permissions = []
    },
    drawerClosePermissions () {
      let that = this.formItem
      that.id = 0
      that.name = ''
      that.description = ''
      that.users = []
      that.groups = []
      that.permissions = []
    },
    handleChangePermissions (value) {
      this.changePermissions = value
      this.getRolesList()
    },
    handleDelete (params) {
      deleteRole(params.row.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getRolesList()
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    },
    getRolesList (value = 1) {
      this.page = value
      let params = {
        'size': this.size,
        'page': this.page
      }
      getRoles(params).then(res => {
        this.tableData = res.data.results
        this.count = res.data.count
      })
    },
    getNoSelectPermission () {
      let that = this
      that.no_select_permission = []
      getAllPermission().then(res => {
        if (res.status === 200) {
          let result = res.data
          for (let i in result) {
            that.no_select_permission.push({
              key: result[i].id,
              label: result[i].name
            })
          }
        }
      })
    },
    permissionChange (newTargetKeys) {
      this.formItem.permissions = newTargetKeys
    },
    groupChange (newTargetKeys) {
      this.formItem.groups = newTargetKeys
    },
    userChange (newTargetKeys) {
      this.formItem.users = newTargetKeys
    },
    getNoSelectUser () {
      let that = this
      that.no_select_user = []
      GetALLUsers().then(res => {
        if (res.status === 200) {
          let result = res.data
          for (let i in result) {
            that.no_select_user.push({
              key: result[i].id,
              label: result[i].name
            })
          }
        }
      })
    },
    getNoSelectGroup () {
      let that = this
      that.no_select_group = []
      getAllGroup().then(res => {
        if (res.status === 200) {
          let result = res.data
          for (let i in result) {
            that.no_select_group.push({
              key: result[i].id,
              label: result[i].name
            })
          }
        }
      })
    },
    handleTabClick (value) {
      if (value === 'menuPerm') {
        // this.$refs.SpringBoardUserList.getSpringBoradUserList()
      } else if (value === 'operatePerm') {
      } else if (value === 'dataPerm') {
      }
    }
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
